import { Route, Routes } from 'react-router-dom';
import Additem from './Components/AddItem/Additem';
import RequireAuth from './Components/Auth/RequireAuth/RequireAuth';
import Blogs from './Components/Blogs/Blogs';
import Home from './Components/Home/Home';
import Inventory from './Components/Inventory/Inventory';
import ManageItem from './Components/ManageItem/ManageItem';
import ManageWatch from './Components/ManageWatch/ManageWatch';
import MyItem from './Components/MyItem/MyItem';
import Login from './Components/RegistationAndLogin/Login/Login';
import Signup from './Components/RegistationAndLogin/Sugnup/Signup';
import Footer from './Components/Shared/Footer/Footer';
import Header from './Components/Shared/Heder/Header';
import Notfound from './Components/Shared/Notfound';
import './App.css';
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import ClockLoader from "react-spinners/ClockLoader";
import CotactUs from './Components/ContactUs/CotactUs';


function App() {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);

  }, []);

  return (

    <>
      {
        loading ?
          <div className="w-100 h-100 d-flex justify-content-center align-items-center mt-5" >
            <ClockLoader color={"#22d3ee"} loading={loading} size={300} />
          </div>
          :
          <div className='app'>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/watch/:watchId" element={
                <RequireAuth>
                  <ManageWatch />
                </RequireAuth>}
              />
              <Route path="/manage" element={
                <RequireAuth>
                  <ManageItem />
                </RequireAuth>
              } />
              <Route path="/addItem" element={
                <RequireAuth>
                  <Additem />
                </RequireAuth>
              } />
              <Route path="/myItem" element={
                <RequireAuth>
                  <MyItem />
                </RequireAuth>
              } />
              <Route path="/contact" element={<CotactUs/>} />
              {/* not found */}
              <Route path="*" element={<Notfound />} />
            </Routes>
            <Footer />
            <ToastContainer></ToastContainer>
          </div>
      }


    </>


  );
}

export default App;
